var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElmologo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elmo Square Logo"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 3",
    width: 60,
    height: 60,
    rx: 4.5,
    fill: "#C72636"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Mouth",
    d: "M51.5594 37.118L8.59489 37.118C9.6616 45.5244 12.9801 55.9563 29.6452 55.9563C44.9343 55.9563 51.7054 43.728 51.5594 37.118Z",
    fill: "#000101",
    stroke: "black",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eyes"
  }, /*#__PURE__*/React.createElement("g", {
    id: "R EYE"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 12",
    d: "M12.0339 12.2395C12.5861 16.3822 15.6524 19.7732 20.2088 19.1659C24.7653 18.5586 29.4615 14.133 28.9093 9.99026C28.3572 5.84757 23.8408 3.03156 19.2843 3.63886C14.7279 4.24617 11.4817 8.0968 12.0339 12.2395Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 14",
    cx: 3.02661,
    cy: 3.02693,
    rx: 3.02661,
    ry: 3.02693,
    transform: "matrix(-0.991233 0.132116 0.132116 0.991236 24.2091 9.08984)",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    id: "L EYE"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 12_2",
    d: "M47.3231 11.5617C47.5428 15.7557 45.1403 19.6715 40.5274 19.9131C35.9145 20.1548 30.4584 16.6506 30.2386 12.4566C30.0188 8.26258 33.9599 4.64691 38.5728 4.40528C43.1857 4.16365 47.1033 7.36768 47.3231 11.5617Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 15",
    cx: 3.0414,
    cy: 3.04173,
    rx: 3.0414,
    ry: 3.04173,
    transform: "matrix(0.998631 -0.0523092 0.0523267 0.99863 34.5159 9.73157)",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Nose",
    d: "M19.0584 27.7169C19.8867 33.931 25.2056 36.0587 30.3834 35.3686C35.5612 34.6785 39.0872 29.0816 38.259 22.8675C37.4308 16.6535 33.6369 11.6505 28.4591 12.3406C23.2814 13.0307 18.2302 21.5029 19.0584 27.7169Z",
    fill: "#EE8034"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 34",
    d: "M32.3157 12.1157C32.3376 14.6034 32.8638 16.7906 34.2168 18.4109C35.5612 20.0211 37.7739 21.133 41.3036 21.3685C44.5495 21.3368 46.8741 20.192 48.3861 18.4762C49.9063 16.7511 50.6357 14.4134 50.6141 11.9551C50.5718 7.15029 46.3846 3.7391 41.1348 3.78517C35.913 3.831 32.2731 7.28589 32.3157 12.1157Z",
    stroke: "#3A3A3A",
    strokeWidth: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 21",
    d: "M32.1047 11.798C30.4458 11.5216 29.5165 11.4179 27.3795 11.7028",
    stroke: "#3A3A3A",
    strokeWidth: 0.75,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 35",
    d: "M9.04565 11.5917C9.06755 14.0793 9.59382 16.2665 10.9467 17.8869C12.2911 19.4971 14.5039 20.6089 18.0336 20.8444C21.2795 20.8127 23.6041 19.668 25.1161 17.9522C26.6363 16.227 27.3657 13.8893 27.344 11.4311C27.3017 6.62624 23.1145 3.21505 17.8648 3.26113C12.643 3.30696 9.00313 6.76184 9.04565 11.5917Z",
    stroke: "#3A3A3A",
    strokeWidth: 0.75
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElmologo);
export default __webpack_public_path__ + "static/media/elmologo.c76f589ff8745be58a5f5bf97b7c805e.svg";
export { ForwardRef as ReactComponent };